<template>
  <div>
    <v-container>
      <employee-selection
        :show-dense="false"
        :show-select="true"
      ></employee-selection>
      <br />
      Date of End Contract
      <v-row>
        <v-col cols="12" md="4" sm="6" xs="12" :class="classPadding">
          <custom-datepicker
            :class-padding="classPadding"
            label="Date From"
            v-model="dateFrom"
          ></custom-datepicker>
        </v-col>
        <v-col cols="12" md="4" sm="6" xs="12" :class="classPadding">
          <custom-datepicker
            :class-padding="classPadding"
            label="Date To"
            v-model="dateTo"
          ></custom-datepicker>
        </v-col>
        <v-col cols="12" md="3" sm="4" xs="12" :class="classPadding">
          <v-checkbox
            label="Listing"
            v-model="listing"
            :class="classPadding"
          ></v-checkbox>
        </v-col>
      </v-row>
      <v-row>
        <v-col xs="12" sm="12" md="12" :class="classPadding">
          <v-btn
            outlined
            @click.stop="exportReport"
            :loading="loading"
            :class="classPadding"
            >Export</v-btn
          >
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
import EventBus from "../../../events/eventBus";
import moment from "moment";
const CustomDatepicker = () => import("../../../components/CustomDatepicker");
const EmployeeSelection = () =>
  import("../../maintenance/employee-masterfile/personal-info/Selection");

const API_ENDPOINT = "/api/reports";
export default {
  data: () => ({
    classPadding: "my-0 py-0",
    selectedEmployees: [],
    dateFrom: null,
    dateTo: null,
    listing: false,
    loading: false,
  }),
  components: {
    EmployeeSelection,
    CustomDatepicker,
  },
  computed: {
    empCodes() {
      return this.selectedEmployees.join(", ");
    },
  },
  methods: {
    exportReport() {
      this.loading = true;

      var data = {
        DateFrom: moment(this.dateFrom).format("MM/DD/YYYY"),
        DateTo: moment(this.dateTo).format("MM/DD/YYYY"),
        Listing: this.listing,
        EmpCode: this.empCodes,
      };
      this.$axios
        .post(`${API_ENDPOINT}/extension-of-contract`, data)
        .then(({ data }) => {
          var subPath = process.env.VUE_APP_PATH;

          window.open(
            `${subPath.slice(0, -1)}/report-viewer?reportCode=${
              data.reportCode
            }&dbName=${data.dbName}&key=${data.key}&companyKey=${
              data.companyKey
            }&reportUrl=${data.url}&client=${data.client}&logoAlign=${
              data.logoAlign
            }&logoWidth=${data.logoWidth}&rpt=${data.rpt}`
          );
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  mounted() {
    EventBus.$on("SELECTED_EMPLOYEE", (payload) => {
      var empCodes = payload.map((item) => {
        return item.empCode;
      });
      this.selectedEmployees = empCodes;
    });
  },
};
</script>
